/** User Profile */
export const SET_AUTH = 'setAuth'
export const SET_PROFILE = 'setProfile'
export const PURGE_AUTH = 'logOut'
export const SET_MY_EVENTS = 'setMyEvents'

/** Event */
export const SET_EVENT_CATEGORIES = 'setEventCategories'
export const SET_EVENTS = 'setEvents'
export const SET_CAT_EVENTS = 'setCatEvents'
export const SET_PROMOTIONAL_EVENTS = 'setPromotionalEvents'
export const SET_PRODUCT_PROMOTIONS = 'setProductPromotions'
export const SET_NEW_ITEM_CAROUSEL = 'setNewItemCarousel'

export const SET_EVENT = 'setEvent'
export const SET_EMPTY_EVENT = 'setEmptyEvent'
export const SET_VIDEOS = 'setVideo'
export const SET_TAGS = 'setTags'

/** Tickets */
export const SET_TICKETS = 'setTickets'
export const SET_TICKET_HOLD_SESSION = 'setTicketHoldSession'
export const SET_TICKET_VALIDATION = 'setTicketValidation'

/**SeatsIO */


/** Ad Banner */
export const SET_BANNER = 'setBanner'

/** General */
export const SET_SYSTEM_CONFIG = 'setSystemConfig'
export const SET_CATEGORY_PROMOTIONAL = 'setCategoryPromotional'
export const SET_SITE_CONTENT = 'setSiteContent'
export const TOGGLE_HEADER_FOOTER = 'toogleHeaderFooter'



/** Search Query */
export const SET_SEARCH_QUERY = 'setSearchQuery'